import React, { FC } from "react";
import { Editor } from "@tiptap/react";
import { IconType } from "react-icons";
import { SVGReactComponent } from "src/@types";
import { AiOutlineClear as CleanIcon } from "react-icons/ai";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";

interface Props {
  editor: Editor;
  icon?: IconType | SVGReactComponent;
}
export const ClearButton: FC<Props> = ({ editor, icon: Icon = CleanIcon }) => {
  const onClick = () => {
    const chain = editor.chain().selectAll().focus();
    chain.clearNodes().unsetAllMarks().blur().run();
  };

  return (
    <Button
      type="button"
      variant={ButtonVariants.SECONDARY}
      className="!rounded-md !duration-100 !p-1 text-red-lighter"
      onClick={onClick}
    >
      <Icon title="clear" className="w-5 h-5" />
    </Button>
  );
};
